declare let THREE: any;
import {DragHandlerBase} from './drag-handler-base';
import {CollisionService} from '../../../../services/collision/collision.service';
import {Injectable} from '@angular/core';

class WallObjectSmartDragHandler extends DragHandlerBase {

  private direction: any;
  private directions: any;
  private moveDirection: any;
  private colliderCache: object;

  constructor(
    nextHandler,
    private collisionSrvc: CollisionService
  ) {
    super(nextHandler);

    this.direction = {
      HORIZONTAL: 0,
      VERCTICAL: 1
    };

    this.directions = [this.direction.HORIZONTAL, this.direction.VERCTICAL];
    this.moveDirection = new THREE.Vector3();
    this.colliderCache = {};
  }

  private getMoveDirection(direction, dragDirection) {
    if (direction === this.direction.HORIZONTAL) {
      this.moveDirection.set(Math.sign(dragDirection.x), 0, Math.sign(dragDirection.z));
    } else {
      this.moveDirection.set(0, Math.sign(dragDirection.y), 0);
    }
    return this.moveDirection.multiplyScalar(3);
  }

  move(e, transformation) {

    const singleObjectDrag = e.draggedObjects.length === 1;
    const {draggedObject, draggedObjectWorldTransform} = e;
    const collidedObject = this.collisionSrvc.isCollide(draggedObject, e.staticObjects, {
      newPosition: transformation.position,
      staticColliderCache: this.colliderCache
    });

    if (singleObjectDrag && collidedObject) {

      const diff = transformation.position.clone().sub(draggedObjectWorldTransform.position),
        dragDirection = diff.clone().normalize();

      for (let i = 0; i < this.directions.length; i++) {
        const direction = this.directions[i];
        const moveDirection = this.getMoveDirection(direction, dragDirection);
        const newPosition = draggedObjectWorldTransform.position.clone().add(moveDirection);
        const collide = this.collisionSrvc.isCollide(draggedObject, [collidedObject], {
          newPosition: newPosition,
          staticColliderCache: this.colliderCache
        });

        if (!collide) {
          transformation.position.copy(draggedObjectWorldTransform.position);
          transformation.position.add(diff.projectOnVector(moveDirection));
          break;
        }
      }
    }

    super.move(e, transformation);
  }

  release(e) {
    this.colliderCache = {};
    super.release(e);
  }
}

@Injectable()
export class WallObjectSmartDragHandlerFactory {

  constructor(
    private collisionSrvc: CollisionService
  ) {

  }

  create(handler?: DragHandlerBase): DragHandlerBase {
    return new WallObjectSmartDragHandler(handler, this.collisionSrvc);
  }
}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/3D/Drag/Handler/wall-object-smart-drag.ts